import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class WorkflowService {
  constructor(private http: HttpClient) {}

  getHistory(id: number) {
    return this.http.get<any>(
      `${environment.apiUrls.workflow}/workflow/${id}/history`
    );
  }

  getSituation(id: number) {
    return this.http.get<boolean>(
      `${environment.apiUrls.workflow}/workflow/${id}/situation`
    );
  }
}
